interface Props {
  email: string;
  name: string;
  onSignOut: () => void | Promise<void>;
}

export function RequestAccess({ email, name, onSignOut }: Props) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-page">
      <div className="bg-surface border border-border rounded-xl p-10 max-w-md w-full text-center">
        <div className="text-2xl font-semibold text-text-primary mb-2">LAOSS Reports</div>
        <div className="text-xs uppercase tracking-wider text-text-hint mb-6">Access pending</div>

        <p className="text-sm text-text-secondary leading-relaxed mb-6">
          Your access request has been submitted. An administrator will review and approve
          your account. You'll be able to sign in once approved.
        </p>

        <div className="bg-page border border-border rounded-lg p-4 mb-6 text-left">
          <div className="text-xs uppercase tracking-wider text-text-hint">Signed in as</div>
          <div className="text-sm text-text-primary mt-1">{name}</div>
          <div className="text-sm text-text-muted">{email}</div>
        </div>

        <button
          onClick={() => onSignOut()}
          className="text-sm text-text-secondary underline"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
